Core.PayrollsRouter = Core.SubRouter.extend({
    routes: {
        'new': 'newPayroll',
        ':id': 'viewPayroll',
        '': 'payrolls',
    },

    newPayroll: function(){
        var existingView = app.view && app.view.collection;
        if (!existingView) history.back();
        app.setMainView(new PayrollView({
            collection: app.view.collection,
            history: false
        }), 'payrolls'); 
    },

    viewPayroll: function(id){
        if (Core.client.hasPermission('create_payroll') &&Core.client.hasPermissionInAnyGroup('create_payroll')
            && Core.client.me.isPlusUser() && Core.client.hasFeature('payrolls')) {
            app.setMainView(new PayrollView({
                collection: new Payrolls({id: id}), 
                history: true
            }), 'payrolls');
        }else{
            app.setMainView(new DashboardView(), 'dashboard');
        }  
    },

    payrolls: function() {
        if (Core.client.hasPermission('create_payroll') && Core.client.hasPermissionInAnyGroup('create_payroll')
            && Core.client.me.isPlusUser() && Core.client.hasFeature('payrolls')) {
            app.setMainView(new PayrollListView(), 'payrolls');
        }else{
            app.setMainView(new DashboardView(), 'dashboard');
        }    
    },
});